import { ChangeDetectionStrategy, Component } from '@angular/core';
import UIConstants from '../../../app-constants/ui-constants';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
notFoundConstants = UIConstants.Not_Found
}
